<template>
  <div class="text-main-text">
    <!-- header -->
    <h1
        class="text-main-text lg:text-4xl text-2xl leading-normal mb-4 lg:mb-6"
    >
      FAQ
    </h1>

    <p class="text-sm lg:text-lg">
      Здесь вы найдете ответы на все часто задаваемые вопросы.
    </p>

    <!-- FAQs -->
    <div class="faqs mt-6 px-4 lg:px-12">
      <div class="mt-6 lg:mt-12" v-for="(faq , index ) in faqs" :key="index" :class="{'faq':index < faqs.length-1}">
        <div class="flex justify-between cursor-pointer" @click="faq.open = !faq.open">
          <h2 class="text-main-text text-sm lg:text-lg pb-4 lg:pb-8 leading-normal">{{ faq.name }}</h2>
          <font-awesome-icon
              :icon="['far', 'angle-down']"
              size="2x"
              :class="[faq.open ?'rotate-arrow':'arrow']"
              fixed-width
              class="w-6 h-6 md:w-8 md:h-8 arrow cursor-pointer md:-mr-3"
              style="color:#979797"

          ></font-awesome-icon>
        </div>
        <transition name="fade">
          <p v-if="faq.open" class="text-main-text text-sm mb-4 mt-2 leading-tight" v-html="faq.description"></p>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      faqs: [

        {
          name: 'Как результаты игр считаются в рейтинге?',
          description: '<p>На позицию в рейтинге влияют количество игр, в которых поучаствовала команда, и количество раз, когда команда заняла призовое место.<br><br>Если команда заняла 1-е, 2-е или 3-е место, ее финальный балл за игру умножается на коэффициент 1.2.<br><br>Остальные команды в таблице, кроме занявших призовые места, делятся на две части. Если число команд нечетное, команда в середине списка относится к тем, кто набрал меньше баллов.<br><br>Команды из первой половины таблицы получают повышающий коэффициент 1.1. А если по итогам игры команда оказалась во второй группе с меньшим количеством баллов, то баллы за игру добавляются к рейтингу без дополнительных коэффициентов.</p> ',
          open: false,
        },

        {
          name: 'Чем отличается общий рейтинг команд от рейтинга Лиги чемпионов?',
          description:
              '<p>Общий рейтинг команд – это рейтинг, в который попадают результаты офлайн-игр всех городов.' +
              ' Вы можете фильтровать таблицу и видеть команды только из вашего населенного пункта или из всех городов.' +
              '<br><br>Рейтинг Лиги чемпионов – это список команд вашего города. В нем определяются топ-команды,' +
              ' которые примут участие в финальной битве игрового сезона – Лиге чемпионов. В этот рейтинг попадают' +
              ' результаты конкретных категорий игр.</p>',
          open: false,
        },

        {
          name: 'Какие игры учитываются в общем рейтинге?',
          description: '<p>В общий рейтинг команд попадают результаты' +
              ' игр классической и тематической Мозгобойни. Не учитываются в рейтинге баллы за участие в Корпоративной' +
              ' Лиге, Английской, Детской, Семейной Мозгобойне, за участие в игре Туц Туц Quiz и за игры, которые' +
              ' проходят в рамках Лиги Чемпионов.</p>',
          open: false,
        },

        {
          name: 'Какие игры учитываются в рейтинге Лиги чемпионов?',
          description: '<p>В рейтинг Лиги чемпионов попадают' +
              ' все классические, специальные (например, Белая Мозгобойня) и все праздничные, но не входят результаты ' +
              'прошлой Лиги чемпионов.</p>',
          open: false,
        },

        {
          name: 'Когда обнуляются рейтинги?',
          description: '<p>Общий рейтинг команд – это рейтинг, который существует на протяжении всех игр и не ' +
              'обнуляется.<br><br>Рейтинг Лиги чемпионов обнуляется сразу после того, как определен топ команд для' +
              ' финальной игры сезона. Следующие игры начинают новый сезон, и команды заново набирают баллы, ' +
              'чтобы попасть в финал предстоящего сезона.</p> ',
          open: false,
        },

        {
          name: 'Не могу найти свою команду в рейтинге.',
          description: '<p>Сначала попробуйте ввести название своей команды в поисковую строку, ' +
              'которая расположена над рейтинговой таблицей. Если команда все-таки не нашлась,' +
              'обратитесь в чат поддержки в правой нижней части экрана.</p> ',
          open: false,
        },

        {
          name: 'Неправильно подсчитаны баллы в рейтинге.',
          description: '<p>Возможно, в одной из игр вы создавали новую команду для участия,' +
              ' и баллы за это мероприятие были подсчитаны отдельно. Обратитесь в чат поддержки в ' +
              'правом нижнем углу экрана, и мы поможем добавить баллы нужной команде.</p>',
          open: false,
        },

        {
          name: 'Что такое ранги?',
          description: '<p>Ранги команд – это система лояльности, в которой команды за достижение определенного' +
              ' количества баллов получают ранг, а вместе с ним – различные бонусы.</p>',
          open: false,
        },
      ],
    };
  },
  computed: {},
};
</script>

<style scoped>
.faqs {
  border: 1px solid #979797;
  box-sizing: border-box;
  border-radius: 10px;
  font-family: Montserrat;
  font-style: normal;
}

.faqs .faq {
  border-bottom: 1px solid #979797;
}

.arrow {
  transition: 0.5s all;
}

.rotate-arrow {
  transform: rotate(180deg);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

</style>
